var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00183105H513V341.991H0V-0.00183105Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.906 98.5322C366.319 75.0825 356.868 49.5788 336.583 36.8761C340.302 37.3574 343.958 38.2379 347.488 39.5022C374.543 49.2091 388.607 79.0072 378.9 106.063C369.193 133.119 339.395 147.181 312.339 137.474C308.81 136.206 305.428 134.562 302.25 132.57C325.983 135.66 349.492 121.983 357.906 98.5322ZM311.244 30.4495L303.933 39.8949L292.691 35.8611L299.416 45.7323L292.105 55.1777L303.571 51.8332L310.296 61.7045L310.658 49.7672L322.124 46.4217L310.881 42.3888L311.244 30.4495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.983 61.2285L323.673 70.6739L312.43 66.6401L319.155 76.5113L311.845 85.9567L323.31 82.6112L330.035 92.4835L330.396 80.5452L341.863 77.1987L330.621 73.1668L330.983 61.2285ZM276.439 41.6584L269.129 51.1038L257.888 47.0719L264.612 56.9422L257.302 66.3866L268.767 63.0421L275.492 72.9133L275.854 60.975L287.32 57.6315L276.077 53.5967L276.439 41.6584ZM275.638 76.9161L268.328 86.3615L257.085 82.3277L263.81 92.1989L256.5 101.644L267.966 98.2998L274.69 108.171L275.053 96.2328L286.519 92.8883L275.277 88.8544L275.638 76.9161ZM309.188 88.9526L301.877 98.398L290.636 94.3641L297.361 104.236L290.049 113.681L301.516 110.336L308.241 120.207L308.602 108.269L320.067 104.925L308.826 100.892L309.188 88.9526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6406 -0.00183105H172.858V341.991H83.6406V-0.00183105Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.687 90.0276L102.75 78.9009V63.1653L117.687 52.0386H138.812L153.749 63.1653V78.9009L138.812 90.0276H117.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.25 52.0386H117.687L102.75 63.1653V70.8583H128.25V52.0386ZM128.25 90.0276H138.812L153.749 78.9009V70.8733H128.25V90.0276Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.687 289.951L102.75 278.824V263.089L117.687 251.962H138.812L153.749 263.089V278.824L138.812 289.951H117.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.25 251.962H117.687L102.75 263.089V270.782H128.25V251.962ZM128.25 289.951H138.812L153.749 278.824V270.797H128.25V289.951Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.688 189.989L102.751 178.862V163.128L117.688 152H138.813L153.75 163.128V178.862L138.813 189.989H117.688ZM154.272 214.47H147.766V207.965H136.333L128.249 199.881L120.166 207.965H108.734V214.47H102.229V227.482H108.734V233.986H120.166L128.25 242.071L136.334 233.986H147.766V227.482H154.272V214.47ZM154.272 114.507H147.766V108.003H136.333L128.249 99.9179L120.166 108.003H108.734V114.507H102.229V127.519H108.734V134.023H120.166L128.25 142.109L136.334 134.023H147.766V127.519H154.272V114.507Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.812 163.556H135.681V178.425H120.812V163.556Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.25 128.446C132.356 128.446 135.685 125.117 135.685 121.01C135.685 116.904 132.356 113.575 128.25 113.575C124.143 113.575 120.814 116.904 120.814 121.01C120.814 125.117 124.143 128.446 128.25 128.446Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.25 228.414C132.356 228.414 135.685 225.085 135.685 220.979C135.685 216.872 132.356 213.543 128.25 213.543C124.143 213.543 120.814 216.872 120.814 220.979C120.814 225.085 124.143 228.414 128.25 228.414Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm);
export default __webpack_public_path__ + "static/media/TM.1128cdd77be98b006191998b5219e55f.svg";
export { ForwardRef as ReactComponent };